function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.0948 15.2381H52.0796C51.659 15.2381 51.3253 15.5795 51.3253 16.0001C51.3253 16.4206 51.6742 16.762 52.0948 16.762C52.5154 16.762 52.8567 16.4206 52.8567 16.0001C52.8567 15.5795 52.5169 15.2381 52.0948 15.2381Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M49.0471 15.2381H49.0319C48.6114 15.2381 48.2776 15.5795 48.2776 16.0001C48.2776 16.4206 48.6266 16.762 49.0471 16.762C49.4677 16.762 49.8091 16.4206 49.8091 16.0001C49.8091 15.5795 49.4692 15.2381 49.0471 15.2381Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9996 15.2381H45.9844C45.5638 15.2381 45.2301 15.5795 45.2301 16.0001C45.2301 16.4206 45.579 16.762 45.9996 16.762C46.4202 16.762 46.7615 16.4206 46.7615 16.0001C46.7615 15.5795 46.4217 15.2381 45.9996 15.2381Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M42.952 15.2381H42.9368C42.5162 15.2381 42.1825 15.5795 42.1825 16.0001C42.1825 16.4206 42.5314 16.762 42.952 16.762C43.3726 16.762 43.7139 16.4206 43.7139 16.0001C43.7139 15.5795 43.3741 15.2381 42.952 15.2381Z",
  fill: "current"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9043 15.2381H39.8891C39.4685 15.2381 39.1348 15.5795 39.1348 16.0001C39.1348 16.4206 39.4838 16.762 39.9043 16.762C40.3249 16.762 40.6663 16.4206 40.6663 16.0001C40.6663 15.5795 40.3264 15.2381 39.9043 15.2381Z",
  fill: "current"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 15.2381H36.8415C36.4209 15.2381 36.0872 15.5795 36.0872 16.0001C36.0872 16.4206 36.4361 16.762 36.8567 16.762C37.2773 16.762 37.6186 16.4206 37.6186 16.0001C37.6186 15.5795 37.2788 15.2381 36.8567 15.2381Z",
  fill: "current"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8091 15.2381H33.7939C33.3733 15.2381 33.0396 15.5795 33.0396 16.0001C33.0396 16.4206 33.3885 16.762 33.8091 16.762C34.2297 16.762 34.571 16.4206 34.571 16.0001C34.571 15.5795 34.2312 15.2381 33.8091 15.2381Z",
  fill: "current"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M49.0471 12.1904H49.0319C48.6114 12.1904 48.2776 12.5317 48.2776 12.9523C48.2776 13.3729 48.6266 13.7142 49.0471 13.7142C49.4677 13.7142 49.8091 13.3729 49.8091 12.9523C49.8091 12.5317 49.4692 12.1904 49.0471 12.1904Z",
  fill: "current"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9996 12.1904H45.9844C45.5638 12.1904 45.2301 12.5317 45.2301 12.9523C45.2301 13.3729 45.579 13.7142 45.9996 13.7142C46.4202 13.7142 46.7615 13.3729 46.7615 12.9523C46.7615 12.5317 46.4217 12.1904 45.9996 12.1904Z",
  fill: "current"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M42.952 12.1904H42.9368C42.5162 12.1904 42.1825 12.5317 42.1825 12.9523C42.1825 13.3729 42.5314 13.7142 42.952 13.7142C43.3726 13.7142 43.7139 13.3729 43.7139 12.9523C43.7139 12.5317 43.3741 12.1904 42.952 12.1904Z",
  fill: "current"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9043 12.1904H39.8891C39.4685 12.1904 39.1348 12.5317 39.1348 12.9523C39.1348 13.3729 39.4838 13.7142 39.9043 13.7142C40.3249 13.7142 40.6663 13.3729 40.6663 12.9523C40.6663 12.5317 40.3264 12.1904 39.9043 12.1904Z",
  fill: "current"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 12.1904H36.8415C36.4209 12.1904 36.0872 12.5317 36.0872 12.9523C36.0872 13.3729 36.4361 13.7142 36.8567 13.7142C37.2773 13.7142 37.6186 13.3729 37.6186 12.9523C37.6186 12.5317 37.2788 12.1904 36.8567 12.1904Z",
  fill: "current"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9996 9.14279H45.9844C45.5638 9.14279 45.2301 9.48415 45.2301 9.90472C45.2301 10.3253 45.579 10.6666 45.9996 10.6666C46.4202 10.6666 46.7615 10.3253 46.7615 9.90472C46.7615 9.48415 46.4217 9.14279 45.9996 9.14279Z",
  fill: "current"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M42.952 9.14279H42.9368C42.5162 9.14279 42.1825 9.48415 42.1825 9.90472C42.1825 10.3253 42.5314 10.6666 42.952 10.6666C43.3726 10.6666 43.7139 10.3253 43.7139 9.90472C43.7139 9.48415 43.3741 9.14279 42.952 9.14279Z",
  fill: "current"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9043 9.14279H39.8891C39.4685 9.14279 39.1348 9.48415 39.1348 9.90472C39.1348 10.3253 39.4838 10.6666 39.9043 10.6666C40.3249 10.6666 40.6663 10.3253 40.6663 9.90472C40.6663 9.48415 40.3264 9.14279 39.9043 9.14279Z",
  fill: "current"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 9.14279H36.8415C36.4209 9.14279 36.0872 9.48415 36.0872 9.90472C36.0872 10.3253 36.4361 10.6666 36.8567 10.6666C37.2773 10.6666 37.6186 10.3253 37.6186 9.90472C37.6186 9.48415 37.2788 9.14279 36.8567 9.14279Z",
  fill: "current"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M42.952 6.09518H42.9368C42.5162 6.09518 42.1825 6.43654 42.1825 6.85712C42.1825 7.27769 42.5314 7.61905 42.952 7.61905C43.3726 7.61905 43.7139 7.27769 43.7139 6.85712C43.7139 6.43654 43.3741 6.09518 42.952 6.09518Z",
  fill: "current"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9043 6.09518H39.8891C39.4685 6.09518 39.1348 6.43654 39.1348 6.85712C39.1348 7.27769 39.4838 7.61905 39.9043 7.61905C40.3249 7.61905 40.6663 7.27769 40.6663 6.85712C40.6663 6.43654 40.3264 6.09518 39.9043 6.09518Z",
  fill: "current"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 6.09518H36.8415C36.4209 6.09518 36.0872 6.43654 36.0872 6.85712C36.0872 7.27769 36.4361 7.61905 36.8567 7.61905C37.2773 7.61905 37.6186 7.27769 37.6186 6.85712C37.6186 6.43654 37.2788 6.09518 36.8567 6.09518Z",
  fill: "current"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9043 3.04761H39.8891C39.4685 3.04761 39.1348 3.38896 39.1348 3.80954C39.1348 4.23011 39.4838 4.57146 39.9043 4.57146C40.3249 4.57146 40.6663 4.23011 40.6663 3.80954C40.6663 3.38896 40.3264 3.04761 39.9043 3.04761Z",
  fill: "current"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 3.04761H36.8415C36.4209 3.04761 36.0872 3.38896 36.0872 3.80954C36.0872 4.23011 36.4361 4.57146 36.8567 4.57146C37.2773 4.57146 37.6186 4.23011 37.6186 3.80954C37.6186 3.38896 37.2788 3.04761 36.8567 3.04761Z",
  fill: "current"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 0H36.8415C36.4209 0 36.0872 0.341357 36.0872 0.761927C36.0872 1.1825 36.4361 1.52385 36.8567 1.52385C37.2773 1.52385 37.6186 1.1825 37.6186 0.761927C37.6186 0.341357 37.2788 0 36.8567 0Z",
  fill: "current"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M49.0471 18.2857H49.0319C48.6114 18.2857 48.2776 18.6271 48.2776 19.0477C48.2776 19.4682 48.6266 19.8096 49.0471 19.8096C49.4677 19.8096 49.8091 19.4682 49.8091 19.0477C49.8091 18.6271 49.4692 18.2857 49.0471 18.2857Z",
  fill: "current"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9996 18.2857H45.9844C45.5638 18.2857 45.2301 18.6271 45.2301 19.0477C45.2301 19.4682 45.579 19.8096 45.9996 19.8096C46.4202 19.8096 46.7615 19.4682 46.7615 19.0477C46.7615 18.6271 46.4217 18.2857 45.9996 18.2857Z",
  fill: "current"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M42.952 18.2857H42.9368C42.5162 18.2857 42.1825 18.6271 42.1825 19.0477C42.1825 19.4682 42.5314 19.8096 42.952 19.8096C43.3726 19.8096 43.7139 19.4682 43.7139 19.0477C43.7139 18.6271 43.3741 18.2857 42.952 18.2857Z",
  fill: "current"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9043 18.2857H39.8891C39.4685 18.2857 39.1348 18.6271 39.1348 19.0477C39.1348 19.4682 39.4838 19.8096 39.9043 19.8096C40.3249 19.8096 40.6663 19.4682 40.6663 19.0477C40.6663 18.6271 40.3264 18.2857 39.9043 18.2857Z",
  fill: "current"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 18.2857H36.8415C36.4209 18.2857 36.0872 18.6271 36.0872 19.0477C36.0872 19.4682 36.4361 19.8096 36.8567 19.8096C37.2773 19.8096 37.6186 19.4682 37.6186 19.0477C37.6186 18.6271 37.2788 18.2857 36.8567 18.2857Z",
  fill: "current"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9996 21.3333H45.9844C45.5638 21.3333 45.2301 21.6747 45.2301 22.0952C45.2301 22.5158 45.579 22.8572 45.9996 22.8572C46.4202 22.8572 46.7615 22.5158 46.7615 22.0952C46.7615 21.6747 46.4217 21.3333 45.9996 21.3333Z",
  fill: "current"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M42.952 21.3333H42.9368C42.5162 21.3333 42.1825 21.6747 42.1825 22.0952C42.1825 22.5158 42.5314 22.8572 42.952 22.8572C43.3726 22.8572 43.7139 22.5158 43.7139 22.0952C43.7139 21.6747 43.3741 21.3333 42.952 21.3333Z",
  fill: "current"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9043 21.3333H39.8891C39.4685 21.3333 39.1348 21.6747 39.1348 22.0952C39.1348 22.5158 39.4838 22.8572 39.9043 22.8572C40.3249 22.8572 40.6663 22.5158 40.6663 22.0952C40.6663 21.6747 40.3264 21.3333 39.9043 21.3333Z",
  fill: "current"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 21.3333H36.8415C36.4209 21.3333 36.0872 21.6747 36.0872 22.0952C36.0872 22.5158 36.4361 22.8572 36.8567 22.8572C37.2773 22.8572 37.6186 22.5158 37.6186 22.0952C37.6186 21.6747 37.2788 21.3333 36.8567 21.3333Z",
  fill: "current"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M42.952 24.3809H42.9368C42.5162 24.3809 42.1825 24.7223 42.1825 25.1428C42.1825 25.5634 42.5314 25.9048 42.952 25.9048C43.3726 25.9048 43.7139 25.5634 43.7139 25.1428C43.7139 24.7223 43.3741 24.3809 42.952 24.3809Z",
  fill: "current"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9043 24.3809H39.8891C39.4685 24.3809 39.1348 24.7223 39.1348 25.1428C39.1348 25.5634 39.4838 25.9048 39.9043 25.9048C40.3249 25.9048 40.6663 25.5634 40.6663 25.1428C40.6663 24.7223 40.3264 24.3809 39.9043 24.3809Z",
  fill: "current"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 24.3809H36.8415C36.4209 24.3809 36.0872 24.7223 36.0872 25.1428C36.0872 25.5634 36.4361 25.9048 36.8567 25.9048C37.2773 25.9048 37.6186 25.5634 37.6186 25.1428C37.6186 24.7223 37.2788 24.3809 36.8567 24.3809Z",
  fill: "current"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9043 27.4285H39.8891C39.4685 27.4285 39.1348 27.7699 39.1348 28.1904C39.1348 28.611 39.4838 28.9524 39.9043 28.9524C40.3249 28.9524 40.6663 28.611 40.6663 28.1904C40.6663 27.7699 40.3264 27.4285 39.9043 27.4285Z",
  fill: "current"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 27.4285H36.8415C36.4209 27.4285 36.0872 27.7699 36.0872 28.1904C36.0872 28.611 36.4361 28.9524 36.8567 28.9524C37.2773 28.9524 37.6186 28.611 37.6186 28.1904C37.6186 27.7699 37.2788 27.4285 36.8567 27.4285Z",
  fill: "current"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8567 30.4761H36.8415C36.4209 30.4761 36.0872 30.8175 36.0872 31.2381C36.0872 31.6586 36.4361 32 36.8567 32C37.2773 32 37.6186 31.6586 37.6186 31.2381C37.6186 30.8175 37.2788 30.4761 36.8567 30.4761Z",
  fill: "current"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7615 15.2381H30.7463C30.3257 15.2381 29.992 15.5795 29.992 16.0001C29.992 16.4206 30.3409 16.762 30.7615 16.762C31.1821 16.762 31.5234 16.4206 31.5234 16.0001C31.5234 15.5795 31.1836 15.2381 30.7615 15.2381Z",
  fill: "current"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7138 15.2381H27.6986C27.278 15.2381 26.9443 15.5795 26.9443 16.0001C26.9443 16.4206 27.2933 16.762 27.7138 16.762C28.1344 16.762 28.4758 16.4206 28.4758 16.0001C28.4758 15.5795 28.136 15.2381 27.7138 15.2381Z",
  fill: "current"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6662 15.2381H24.651C24.2304 15.2381 23.8967 15.5795 23.8967 16.0001C23.8967 16.4206 24.2457 16.762 24.6662 16.762C25.0868 16.762 25.4282 16.4206 25.4282 16.0001C25.4282 15.5795 25.0883 15.2381 24.6662 15.2381Z",
  fill: "current"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6187 15.2381H21.6035C21.1829 15.2381 20.8492 15.5795 20.8492 16.0001C20.8492 16.4206 21.1981 16.762 21.6187 16.762C22.0393 16.762 22.3806 16.4206 22.3806 16.0001C22.3806 15.5795 22.0408 15.2381 21.6187 15.2381Z",
  fill: "current"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M18.571 15.2381H18.5557C18.1352 15.2381 17.8015 15.5795 17.8015 16.0001C17.8015 16.4206 18.1504 16.762 18.571 16.762C18.9915 16.762 19.3329 16.4206 19.3329 16.0001C19.3329 15.5795 18.9931 15.2381 18.571 15.2381Z",
  fill: "current"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8091 18.2857H33.7939C33.3733 18.2857 33.0396 18.6271 33.0396 19.0477C33.0396 19.4682 33.3885 19.8096 33.8091 19.8096C34.2297 19.8096 34.571 19.4682 34.571 19.0477C34.571 18.6271 34.2312 18.2857 33.8091 18.2857Z",
  fill: "current"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7615 18.2857H30.7463C30.3257 18.2857 29.992 18.6271 29.992 19.0477C29.992 19.4682 30.3409 19.8096 30.7615 19.8096C31.1821 19.8096 31.5234 19.4682 31.5234 19.0477C31.5234 18.6271 31.1836 18.2857 30.7615 18.2857Z",
  fill: "current"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7138 18.2857H27.6986C27.278 18.2857 26.9443 18.6271 26.9443 19.0477C26.9443 19.4682 27.2933 19.8096 27.7138 19.8096C28.1344 19.8096 28.4758 19.4682 28.4758 19.0477C28.4758 18.6271 28.136 18.2857 27.7138 18.2857Z",
  fill: "current"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6662 18.2857H24.651C24.2304 18.2857 23.8967 18.6271 23.8967 19.0477C23.8967 19.4682 24.2457 19.8096 24.6662 19.8096C25.0868 19.8096 25.4282 19.4682 25.4282 19.0477C25.4282 18.6271 25.0883 18.2857 24.6662 18.2857Z",
  fill: "current"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6187 18.2857H21.6035C21.1829 18.2857 20.8492 18.6271 20.8492 19.0477C20.8492 19.4682 21.1981 19.8096 21.6187 19.8096C22.0393 19.8096 22.3806 19.4682 22.3806 19.0477C22.3806 18.6271 22.0408 18.2857 21.6187 18.2857Z",
  fill: "current"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M18.571 18.2857H18.5557C18.1352 18.2857 17.8015 18.6271 17.8015 19.0477C17.8015 19.4682 18.1504 19.8096 18.571 19.8096C18.9915 19.8096 19.3329 19.4682 19.3329 19.0477C19.3329 18.6271 18.9931 18.2857 18.571 18.2857Z",
  fill: "current"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8091 12.1904H33.7939C33.3733 12.1904 33.0396 12.5317 33.0396 12.9523C33.0396 13.3729 33.3885 13.7142 33.8091 13.7142C34.2297 13.7142 34.571 13.3729 34.571 12.9523C34.571 12.5317 34.2312 12.1904 33.8091 12.1904Z",
  fill: "current"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7615 12.1904H30.7463C30.3257 12.1904 29.992 12.5317 29.992 12.9523C29.992 13.3729 30.3409 13.7142 30.7615 13.7142C31.1821 13.7142 31.5234 13.3729 31.5234 12.9523C31.5234 12.5317 31.1836 12.1904 30.7615 12.1904Z",
  fill: "current"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7138 12.1904H27.6986C27.278 12.1904 26.9443 12.5317 26.9443 12.9523C26.9443 13.3729 27.2933 13.7142 27.7138 13.7142C28.1344 13.7142 28.4758 13.3729 28.4758 12.9523C28.4758 12.5317 28.136 12.1904 27.7138 12.1904Z",
  fill: "current"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6662 12.1904H24.651C24.2304 12.1904 23.8967 12.5317 23.8967 12.9523C23.8967 13.3729 24.2457 13.7142 24.6662 13.7142C25.0868 13.7142 25.4282 13.3729 25.4282 12.9523C25.4282 12.5317 25.0883 12.1904 24.6662 12.1904Z",
  fill: "current"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6187 12.1904H21.6035C21.1829 12.1904 20.8492 12.5317 20.8492 12.9523C20.8492 13.3729 21.1981 13.7142 21.6187 13.7142C22.0393 13.7142 22.3806 13.3729 22.3806 12.9523C22.3806 12.5317 22.0408 12.1904 21.6187 12.1904Z",
  fill: "current"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M18.571 12.1904H18.5557C18.1352 12.1904 17.8015 12.5317 17.8015 12.9523C17.8015 13.3729 18.1504 13.7142 18.571 13.7142C18.9915 13.7142 19.3329 13.3729 19.3329 12.9523C19.3329 12.5317 18.9931 12.1904 18.571 12.1904Z",
  fill: "current"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0077 15.2134H15.9924C15.5719 15.2134 15.2382 15.5548 15.2382 15.9753C15.2382 16.3959 15.5871 16.7373 16.0077 16.7373C16.4282 16.7373 16.7696 16.3959 16.7696 15.9753C16.7696 15.5548 16.4297 15.2134 16.0077 15.2134Z",
  fill: "current"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9601 15.2134H12.9448C12.5243 15.2134 12.1906 15.5548 12.1906 15.9753C12.1906 16.3959 12.5395 16.7373 12.9601 16.7373C13.3806 16.7373 13.722 16.3959 13.722 15.9753C13.722 15.5548 13.3821 15.2134 12.9601 15.2134Z",
  fill: "current"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M9.91238 15.2134H9.89716C9.4766 15.2134 9.14288 15.5548 9.14288 15.9753C9.14288 16.3959 9.49181 16.7373 9.91238 16.7373C10.3329 16.7373 10.6743 16.3959 10.6743 15.9753C10.6743 15.5548 10.3345 15.2134 9.91238 15.2134Z",
  fill: "current"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M6.86478 15.2134H6.84956C6.42899 15.2134 6.09528 15.5548 6.09528 15.9753C6.09528 16.3959 6.4442 16.7373 6.86478 16.7373C7.28535 16.7373 7.6267 16.3959 7.6267 15.9753C7.6267 15.5548 7.28685 15.2134 6.86478 15.2134Z",
  fill: "current"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M3.81717 15.2134H3.80195C3.38138 15.2134 3.04767 15.5548 3.04767 15.9753C3.04767 16.3959 3.3966 16.7373 3.81717 16.7373C4.23774 16.7373 4.5791 16.3959 4.5791 15.9753C4.5791 15.5548 4.23924 15.2134 3.81717 15.2134Z",
  fill: "current"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M0.7695 15.2134H0.754286C0.333714 15.2134 0 15.5548 0 15.9753C0 16.3959 0.348929 16.7373 0.7695 16.7373C1.19007 16.7373 1.53143 16.3959 1.53143 15.9753C1.53143 15.5548 1.19164 15.2134 0.7695 15.2134Z",
  fill: "current"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0077 18.2612H15.9924C15.5719 18.2612 15.2382 18.6025 15.2382 19.0231C15.2382 19.4437 15.5871 19.785 16.0077 19.785C16.4282 19.785 16.7696 19.4437 16.7696 19.0231C16.7696 18.6025 16.4297 18.2612 16.0077 18.2612Z",
  fill: "current"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9601 18.2612H12.9448C12.5243 18.2612 12.1906 18.6025 12.1906 19.0231C12.1906 19.4437 12.5395 19.785 12.9601 19.785C13.3806 19.785 13.722 19.4437 13.722 19.0231C13.722 18.6025 13.3821 18.2612 12.9601 18.2612Z",
  fill: "current"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M9.91238 18.2612H9.89716C9.4766 18.2612 9.14288 18.6025 9.14288 19.0231C9.14288 19.4437 9.49181 19.785 9.91238 19.785C10.3329 19.785 10.6743 19.4437 10.6743 19.0231C10.6743 18.6025 10.3345 18.2612 9.91238 18.2612Z",
  fill: "current"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M6.86478 18.2612H6.84956C6.42899 18.2612 6.09528 18.6025 6.09528 19.0231C6.09528 19.4437 6.4442 19.785 6.86478 19.785C7.28535 19.785 7.6267 19.4437 7.6267 19.0231C7.6267 18.6025 7.28685 18.2612 6.86478 18.2612Z",
  fill: "current"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M3.81717 18.2612H3.80195C3.38138 18.2612 3.04767 18.6025 3.04767 19.0231C3.04767 19.4437 3.3966 19.785 3.81717 19.785C4.23774 19.785 4.5791 19.4437 4.5791 19.0231C4.5791 18.6025 4.23924 18.2612 3.81717 18.2612Z",
  fill: "current"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M0.7695 18.2612H0.754286C0.333714 18.2612 0 18.6025 0 19.0231C0 19.4437 0.348929 19.785 0.7695 19.785C1.19007 19.785 1.53143 19.4437 1.53143 19.0231C1.53143 18.6025 1.19164 18.2612 0.7695 18.2612Z",
  fill: "current"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0077 12.1658H15.9924C15.5719 12.1658 15.2382 12.5072 15.2382 12.9277C15.2382 13.3483 15.5871 13.6897 16.0077 13.6897C16.4282 13.6897 16.7696 13.3483 16.7696 12.9277C16.7696 12.5072 16.4297 12.1658 16.0077 12.1658Z",
  fill: "current"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9601 12.1658H12.9448C12.5243 12.1658 12.1906 12.5072 12.1906 12.9277C12.1906 13.3483 12.5395 13.6897 12.9601 13.6897C13.3806 13.6897 13.722 13.3483 13.722 12.9277C13.722 12.5072 13.3821 12.1658 12.9601 12.1658Z",
  fill: "current"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M9.91238 12.1658H9.89716C9.4766 12.1658 9.14288 12.5072 9.14288 12.9277C9.14288 13.3483 9.49181 13.6897 9.91238 13.6897C10.3329 13.6897 10.6743 13.3483 10.6743 12.9277C10.6743 12.5072 10.3345 12.1658 9.91238 12.1658Z",
  fill: "current"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M6.86478 12.1658H6.84956C6.42899 12.1658 6.09528 12.5072 6.09528 12.9277C6.09528 13.3483 6.4442 13.6897 6.86478 13.6897C7.28535 13.6897 7.6267 13.3483 7.6267 12.9277C7.6267 12.5072 7.28685 12.1658 6.86478 12.1658Z",
  fill: "current"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M3.81717 12.1658H3.80195C3.38138 12.1658 3.04767 12.5072 3.04767 12.9277C3.04767 13.3483 3.3966 13.6897 3.81717 13.6897C4.23774 13.6897 4.5791 13.3483 4.5791 12.9277C4.5791 12.5072 4.23924 12.1658 3.81717 12.1658Z",
  fill: "current"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M0.7695 12.1658H0.754286C0.333714 12.1658 0 12.5072 0 12.9277C0 13.3483 0.348929 13.6897 0.7695 13.6897C1.19007 13.6897 1.53143 13.3483 1.53143 12.9277C1.53143 12.5072 1.19164 12.1658 0.7695 12.1658Z",
  fill: "current"
});

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 32,
    viewBox: "0 0 53 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.5c392cc6.svg";
export { ForwardRef as ReactComponent };